import { Pipe, PipeTransform } from '@angular/core';
import { ShortDisplayValuePipe } from './short-display-value.pipe';

export const SHORT_NUMBER_FLOOR = 100;

@Pipe({
  standalone: true,
  name: 'shortNumberWithFloor'
})
export class ShortNumberWithFloorPipe implements PipeTransform {

  private shortDisplayValuePipe = new ShortDisplayValuePipe();

  transform(value: number, minValue: number = SHORT_NUMBER_FLOOR): string {
    return this.shortDisplayValuePipe.transform(value, true, minValue);
  }

}
